import "./App.css";
import WeatherApp from "./WeatherApp";

export default function App() {
  return (
    <div className="container">
      <div className="App">
        <WeatherApp defaultCity="Dublin" />
      </div>
      <p className="opensource">
        <a
          href="https://github.com/annmariemcq/weather-app-react"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code
        </a>
        , by AnnMarie McQuaid
      </p>
    </div>
  );
}
